// client/src/api/axiosInstance.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://api.smsorbit.in/api",
  withCredentials: false,
});

// ================= REQUEST =================
api.interceptors.request.use((config) => {
  const raw = localStorage.getItem("userInfo");

  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.accessToken) {
        config.headers.Authorization = `Bearer ${parsed.accessToken}`;
      }
    } catch {}
  }

  return config;
});

// ================= RESPONSE =================
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const raw = localStorage.getItem("userInfo");
        if (!raw) throw new Error("No user");

        const parsed = JSON.parse(raw);

        const refreshRes = await axios.post(
          "https://api.smsorbit.in/api/auth/refresh",
          { refreshToken: parsed.refreshToken }
        );

        parsed.accessToken = refreshRes.data.accessToken;
        localStorage.setItem("userInfo", JSON.stringify(parsed));

        originalRequest.headers.Authorization =
          `Bearer ${refreshRes.data.accessToken}`;

        return api(originalRequest);
      } catch {
        localStorage.removeItem("userInfo");
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
